/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf
     */
    'cardType': GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf
     */
    'expiredDate': string;
}

export const GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum = typeof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum[keyof typeof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum];


